import React from 'react';
import {Link} from "react-router-dom";

function Modal() {

    return (
        <>
            <Link
                to="/accordion"
                className="slick-arrow slick-prev"
            >
                <svg className="ontario-icon" aria-hidden="true" focusable="false"
                     viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                    <path d="M15.4 7.4L14 6l-6 6 6 6 1.4-1.4-4.58-4.6 4.58-4.6z" fill=""/>
                </svg>
            </Link>

            {/*<Link to="/tabs" className="slick-arrow slick-next">*/}
            {/*    <svg className="ontario-icon" aria-hidden="true" focusable="false"*/}
            {/*         viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">*/}
            {/*        <path d="M10 6L8.6 7.4l4.58 4.6-4.58 4.6L10 18l6-6-6-6z" fill=""/>*/}
            {/*    </svg>*/}
            {/*</Link>*/}


            <main id="content" role="main">
                <div className="ontario-row">
                    <div
                        className="ontario-column ontario-small-push-2 ontario-small-8 ontario-margin-top-24-! ontario-margin-bottom-16-!">

                        <h1>Modal</h1>

                        {/*<section>*/}
                        {/*    <div className="ontario-row">*/}
                        {/*        <div*/}
                        {/*            className="ontario-column ontario-small-push-2 ontario-small-8 ontario-margin-top-24-! ontario-margin-bottom-16-!">*/}
                        {/*            <header className="content-header">*/}
                        {/*               */}
                        {/*            </header>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</section>*/}
                    </div>
                </div>
            </main>

        </>
    );
}

export default Modal;